exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bar_acessibilidade{margin-top:9px;margin-bottom:-9px;padding-bottom:7px;border-bottom:1px solid #f2f2f2}.linkacessib{font-size:12px;margin-right:9px}.linkacessib span{padding:1px 3px;background-color:blue;color:#fff;font-size:11px}.bgpreto{background:#000!important}.textobranco{color:#fff!important}.textopreto{color:#000!important}.linkamarelo{color:#fff333!important;background-color:#000!important}.page-sidebar .page-sidebar-menu .sub-menu>li:hover>a{background:transparent!important}ul>li:hover>a.linkamarelo{background-color:#000!important}.bgbranco{background:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/layout/header/header.vue
// module id = 158
// module chunks = 0